import Table from 'apollo-react/components/Table';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { handleErrors } from '../../../../actions/ErrorActions';
import { getExternalApiResults } from '../../../../api/external-api';
import {
  compareStrings,
  createCustomCell,
  createStringSearchFilter,
} from '../../../../components/SavedSearchesTable/utils';
import { getFilterComponentByDataType } from '../../../../components/TableFilters';
import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { insert } from '../../../../utils/ramdaUtils';
import { getTranslations } from '../../../selectors/common.selectors';

const ExternalApiResultTable = ({ dynamicParamCollection, extraColumns, rowsPerPageOptions }) => {
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const [data, setData] = useState({ columns: [], rows: [] });
  const [isLoading, setIsLoading] = useState(false);

  const translations = useSelector(getTranslations);

  const addExtraColumns = (columns, extraColumns) => {
    return extraColumns.reduce((cols, extraCol) => {
      const idx = typeof extraCol.index === 'number' ? extraCol.index : cols.length;
      let newExtraColumn = extraCol;

      if (newExtraColumn.accessor === 'SELECT_ALL_HEADER') {
        // pass rows array to column header checkbox component
        newExtraColumn = { ...newExtraColumn, header: newExtraColumn.header(data.rows) };
      }

      if (newExtraColumn.accessor === 'select') {
        // pass columns array to column customCell component
        newExtraColumn = {
          ...newExtraColumn,
          customCell: newExtraColumn.customCell(columns),
        };
      }

      return insert(idx, newExtraColumn, cols);
    }, columns);
  };

  const modifyColumns = (columns) => {
    if (_.isNil(columns)) {
      return [];
    }

    return columns.map((column) => ({
      ...column,
      sortFunction: compareStrings,
      filterComponent: getFilterComponentByDataType(column.dataType),
      filterFunction: createStringSearchFilter(column.accessor),
      customCell: createCustomCell(column, translations),
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const response = await getExternalApiResults(dynamicParamCollection);

      if (response.hasError) {
        dispatch(handleErrors(response.errors, { isTopBanner: true }));
      } else {
        const {
          SearchData: { columns, rows },
        } = response;
        setData({ columns: modifyColumns(columns), rows });
      }
      setIsLoading(false);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Table
      title={translateString('Records')}
      columns={addExtraColumns(data.columns, extraColumns)}
      rows={data.rows}
      emptyProps={{
        text: translateString('No data to display'),
      }}
      isLoading={isLoading}
      initialSortOrder="asc"
      showFilterIcon
      rowsPerPageOptions={rowsPerPageOptions}
    />
  );
};

export default ExternalApiResultTable;
